import { Link } from 'react-router-dom';

const NOTICES = [
  { icon: 'ri-shield-check-line', text: '本站为影视内容展示与检索演示平台，所有影片信息均为演示数据。' },
  { icon: 'ri-closed-captioning-line', text: '片源均标注中文字幕状态，方便用户按需选择观看。' },
  { icon: 'ri-bookmark-line', text: '收藏功能保存在本地浏览器中，刷新页面后依然保留。' },
  { icon: 'ri-information-line', text: '播放区域为界面演示，不提供实际视频流播放能力。' },
];

export default function IntroSection() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="w-1 h-6 md:h-7 rounded-full bg-accent-500"></span>
            <h2 className="font-heading font-bold text-lg md:text-2xl text-foreground-950">关于中文字幕永久在线</h2>
          </div>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            中文字幕永久在线是一个专注于中文观影用户的内容门户，汇集高清电影与电视剧资源，覆盖科幻、动作、爱情、悬疑、古装等主流类型。
            我们希望通过清晰的分类、便捷的筛选与检索，帮助每位用户都能快速找到想看的作品。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
            平台持续更新资源库，配合编辑团队策划的主题片单与热门排行，让选片这件事变得轻松又有趣。无论你是偏爱院线大片的影迷，
            还是喜欢追更剧集的追剧党，都能在这里找到属于自己的观影节奏。
          </p>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/about"
              className="flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
            <Link
              to="/category/featured"
              className="flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 hover:border-primary-400 hover:text-primary-600 text-foreground-700 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
            >
              浏览专题片单
            </Link>
          </div>
        </div>

        <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-8">
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-5">用户须知</h3>
          <ul className="space-y-4">
            {NOTICES.map((item) => (
              <li key={item.text} className="flex items-start gap-3">
                <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={`${item.icon} text-base`} aria-hidden="true"></i>
                </span>
                <p className="text-sm text-foreground-700 leading-relaxed pt-1">{item.text}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}